import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import moment from 'moment';
import { styleSheet } from './styles';

interface IProps {
	item: Api.ActionItemEventViewModel;
}

export const ActionItemSubtitle = ({ item }: IProps) => {
	return (
		<div className={css(styleSheet.actionItemSubtitle)}>
			{item.actionItem.dueDate && (
				<div>
					<span className={css(styleSheet.actionItemSubtitleLabel)}>Due: </span>
					<span className={css(styleSheet.actionItemSubtitleDueDate)}>
						<time
							dateTime={moment(item.actionItem.dueDate).format('YYYY-MM-DD')}
							className={css(styleSheet.actionItemSubtitleDueDate)}
						>
							{moment(item.actionItem.dueDate).format('MM/DD/YYYY')}
						</time>
					</span>
				</div>
			)}
			{item.actionItem.assignee && (
				<div className={css(styleSheet.actionItemSubtitleAssignedTo)}>
					<span className={css(styleSheet.actionItemSubtitleLabel)}>Assigned to: </span>
					<span className={css(styleSheet.actionItemSubtitleButton)}>
						{[item.actionItem.assignee.firstName, item.actionItem.assignee.lastName].filter(Boolean).join(' ')}
					</span>
				</div>
			)}
		</div>
	);
};
